import store from 'source/store';

function checkIfUserIsOrgExec(to, from, next) {
    const user = store.state.auth.user;
    if (!user) {
        next({ name: 'signin', replace: true });
    }
    const { is_organizational_exec } = user.user_profile;
    if (is_organizational_exec)
        next({ name: 'page-not-found', replace: true });
    else next();
}

export default [{
    path: '/profile',
    name: 'profile-internal-root',
    component: () => import(
        'source/pages/root/InternalPageRoot.vue'),
    beforeEnter: checkIfUserIsOrgExec,
    meta: {
        title: 'Profile Page Root',
        loginRequired: true,
        isInternal: true,
        isCompanyIndependent: true
    },
    children: [
        {
            path: '',
            name: 'profile-root',
            component: () => import('source/pages/root/ProfilePageGroup.vue'),
            meta: {
                title: 'Profile Page',
                isInternal: true,
                isCompanyIndependent: true
            },
            children: [
                {
                    path: 'user-profile',
                    name: 'profile-main',
                    component: () => import('source/pages/profile/ProfileMainPage.vue'),
                    meta: {
                        title: 'Profile - HQZen',
                        isInternal: true,
                        isCompanyIndependent: true
                    }
                },
                {
                    path: 'preferences',
                    name: 'profile-job-preferences',
                    component: () => import('source/pages/profile/ProfileJobPreferencesPage.vue'),
                    meta: {
                        title: 'Job Preferences - HQZen',
                        isInternal: true,
                        isCompanyIndependent: true
                    }
                },
                {
                    path: 'work',
                    name: 'profile-work-experience',
                    component: () => import('source/pages/profile/ProfileWorkExperiencePage.vue'),
                    meta: {
                        title: 'Work Experience - HQZen',
                        isInternal: true,
                        isCompanyIndependent: true
                    }
                },
                {
                    path: 'school',
                    name: 'profile-educational-background',
                    component: () => import('source/pages/profile/ProfileEducBackgroundPage.vue'),
                    meta: {
                        title: 'Educational Background - HQZen',
                        isInternal: true,
                        isCompanyIndependent: true
                    }
                }
            ]
        }
    ]
}];
